import { render, staticRenderFns } from "./ConsultaDocumentos.vue?vue&type=template&id=6025c3c4&scoped=true"
import script from "./ConsultaDocumentos.vue?vue&type=script&lang=js"
export * from "./ConsultaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ConsultaDocumentos.vue?vue&type=style&index=0&id=6025c3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025c3c4",
  null
  
)

export default component.exports